import React, { useState, useEffect, useRef } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import logo from "../../common/media/cc_logo_white.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Popover from "../../common/components/popover/popover.js";
import { projects as getProjects } from '../../common/api/projects';
import ProjectsList from "./../Projects/ProjectsList";
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';
import logoGrey from '../../common/media/cc_logo_grey.svg';

const LandingPage = ({ merchantCode, fetchedImpact }) => {
    const [projects, setProjects] = useState();
    
    const numberOfContributions = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactValue = fetchedImpact && !fetchedImpact.error && Math.round(fetchedImpact.carbonOffsetImpact?.value);
    const carbonOffsetImpactGlass = formatNumber(Math.floor(carbonOffsetImpactValue/3*5));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit.toLowerCase()
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears} trees have in one year.`;
    
        
    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    return (
        <div>
            <div className="transparent-header">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-auto">
                            {/*<a href="https://forest.carbon.click/" target="_blank">*/}
                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644390819/Enterprise/One%20Good%20Turn/Bird_Graphic-12_1_sz7yhp.png`} style={{height: '120px'}} />
                            {/*</a>*/}
                        </div>
                    </div>
                                        
                </div>
            </div>
            <div className="w-100 position-relative img-cover hero-img" >
               
                <div className="container text-align-start">
                    <div className="row align-items-center">
                        <div className="col-12">
                            <div className="row align-items-end column-rev">
                                <div className="col-lg-6 col-md-7 padding-top">
                                    <h1 className="text-shadow text-primary mt-0">
                                        <small>Sustainable, Responsible, </small>One Good Turn
                                    </h1>
                                    <a target="_blank" href="https://my.carbon.click/" className="btn btn-primary">Reduce my Impact</a>
                                    <div className="d-flex lrg paworedBy align-center">
                                        <p className="m-0 mr-2 font-500">Powered By</p>
                                        <div>
                                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 20 }} src={logoGrey} alt="Carbonclick logo" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-5">
                                    <div className="banner-img">
                                        <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644389444/Enterprise/One%20Good%20Turn/bnr-img_zokm5q.png" alt="image" />
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="two-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="text-box">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644398118/Enterprise/One%20Good%20Turn/GumnutGraphic-13_1_voaw1b.png" />
                                <h2>One Good Turn to make <br/>our range Climate Positive</h2>
                                <p>We've partnered with CarbonClick to double offset the <br/>estimated emissions for each bottle of the One Good <br/>Turn range, by supporting native forest regeneration <br/>projects in Australia, Alaska and Peru. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="customerCarbonImpact text-center">
                <div className="container">
                    <h3 className="mt-0">OUR POSITIVE IMPACT</h3>
                    <div className="mobile-hide text-left">
                        <div className="max-1064 mx-auto">
                            <div className="row">

                                <div className="col-4 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644389444/Enterprise/One%20Good%20Turn/Group_571_moerej.png`} />
                                            </div>
                                            <div className="font-bold">
                                                <h3 className="count-title">{carbonOffsetImpactGlass}</h3>
                                                <p className="my-0">Glasses made Climate Positive</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644389444/Enterprise/One%20Good%20Turn/Group_572_le32ix.png`} />
                                            </div>
                                            <div className="font-bold">
                                                <h3 className="count-title">{carbonOffsetImpact}</h3>
                                                <p className="my-0">{carbonOffsetImpactUnit} of CO2 Offset</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1 w-100">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644389445/Enterprise/One%20Good%20Turn/Group_573_asw4v9.png`}/>
                                            </div>
                                            <div className="font-bold">
                                                <h3 className="count-title">{treeGrowthYears}</h3>
                                                <p className="my-0">Trees &nbsp;
                                                    <Popover content={treeMetric} >
                                                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644400793/Enterprise/One%20Good%20Turn/Exclude_mb6nev.png`} alt=""/>
                                                    </Popover>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="mobile-show mt-4 text-center">
                    <div className="container">
                        <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                            <div key="1">
                                <div className="w-100 icn-shdw-bx">
                                    <div>
                                        <div className="img-cover img-1">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644389444/Enterprise/One%20Good%20Turn/Group_571_moerej.png`} />
                                        </div>
                                        <div className="font-bold">
                                            <h3 className="count-title">{carbonOffsetImpactGlass}</h3>
                                            <p className="my-0">Glasses made Climate Positive</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div key="2">
                                <div className="col-4 d-grid">
                                    <div className="w-100 icn-shdw-bx">
                                        <div>
                                            <div className="img-cover img-1">
                                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644389444/Enterprise/One%20Good%20Turn/Group_572_le32ix.png`} />
                                            </div>
                                            <div className="font-bold">
                                                <h3 className="count-title">{carbonOffsetImpact}</h3>
                                                <p className="my-0">{carbonOffsetImpactUnit} of CO2 Offset</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div key="3">
                                <div className="w-100 icn-shdw-bx">
                                    <div>
                                        <div className="img-cover img-1 w-100">
                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644389445/Enterprise/One%20Good%20Turn/Group_573_asw4v9.png`}/>
                                        </div>
                                        <div className="font-bold">
                                            <h3 className="count-title">{treeGrowthYears}</h3>
                                            <p className="my-0">Trees &nbsp;
                                                <Popover content={treeMetric} >
                                                    <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1644400793/Enterprise/One%20Good%20Turn/Exclude_mb6nev.png`} alt=""/>
                                                </Popover>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>

            {Array.isArray(projects) && (
            <div className="projectsSec text-center">
                <div className="container">
                    <div className="max-1064 mx-auto">
                        <h2 className="font-bold m-0">Support Projects That Fight Climate Change</h2>
                        <p className="font-18">We support only the highest quality carbon offsetting projects around the <br/>world, to bring you peace of mind and results.</p>
                        <ProjectsList title={null} projects={projects} />
                    </div>
                </div>
            </div>
            )}

            <div className="two-sec leftimg">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 ml-auto">
                            <div className="text-box">
                                <h2>One Bottle at a Time</h2>
                                <p className="lrg">Our wines are organic by nature and vegan friendly. <br/>We are always looking for more ways to support the <br/>earth, whether that is through regenerative practices <br/>or establishing sustainable methods across our <br/>systems. </p>
                                <p className="lrg">One Good Turn is about making the better choices <br/>in our everyday lives to be the best version of our <br/>earthly selves.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="climateSec text-center">
                <div className="container">
                    <h2>What is Climate Positive and how does it work?</h2>
                    <p>One Good Turn have partnered with CarbonClick to make a great wine that is also good for the <br/>environment. By going Climate Positive, we are offsetting twice the estimated carbon footprint of each <br/>bottle, meaning each bottle has a positive impact on the environment.</p>
                    <p className="mb-0">Carbon offsetting is the process of balancing out carbon emissions by buying carbon credits. The <br/>estimated footprint of our wine is around 1.5kg of CO₂e, meaning we buy 3kg of CO₂e per bottle from a <br/>mix of native reforestation credits from Australia, Alaska and Peru.</p>
                </div>
            </div>

            <div className="two-sec faq-sec">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="max-510 text-box">
                                <h2>Climate Friendly FAQs</h2>
                                <div>
                                    <Accordian title={"What are carbon credits"} >
                                        A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.
                                    </Accordian>
                                    <Accordian title={"What does Climate Positive mean?"} >
                                        Climate Positive means that every bottle of One Good Turn is having a positive impact on our climate. This is because the carbon footprint of each bottle is being double offset, meaning its own environmental impact is neutralised two times over, resulting in a net positive contribution to the environment.
                                    </Accordian>
                                    <Accordian title={"Who are CarbonClick?"} >
                                        CarbonClick is a New Zealand technology company that exists to reverse climate change. By making carbon offsetting simple, trustworthy and cost effective,  we empower businesses and their customers with the tools to start tackling their carbon emissions.
                                    </Accordian>
                                    <Accordian title={"Where does the money go?"} >
                                        The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.
                                    </Accordian>
                                </div>
                                <div className="faq-btn">
                                    <a className="btn-primary" href={footerLinks.faq} target="_blank">View All 
                                        <svg className="ml-2" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 1.25L1.22222 0L6.11113 4.99999L1.22225 10L2.47261e-05 8.75L3.66667 5.00001L0 1.25Z" fill="white"/>
                                            <path d="M6.11111 0L4.88889 1.25L8.55556 5.00001L4.88892 8.75L6.11114 10L11 5.00001L6.11111 0Z" fill="white"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="w-100 footer-img" >
                <div className="container color-white">
                    <div className="footerImg">
                        <div className="footer-width">
                            <p className="footer-powered">POWERED BY</p>
                            <div className="row align-items-center">
                                <div className='col-md-auto col-sm-6'>
                                    <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                        <img style={{ height: 24 }} className="footer-logo" src={logo} alt="carbonclick" />
                                    </a>
                                </div>
                                <div className="col-md-4 col-sm-6 ml-auto">
                                    <div className="text-right">
                                        <a className="mr-1" href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                            <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                        </a>
                                        <a className="mr-1" href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                            <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                        </a>
                                        <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                            <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <hr className="footer-hr"/>
                            <div className="row links bottom-links">
                                <div className="col">
                                    <div>
                                        <div className="mb-25"><a className="color-white medium" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                                        <div className="mb-25"><a className="color-white medium" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div>
                                        <div className="mb-25"><a className="color-white medium" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                        <div className="mb-25"><a className="color-white medium" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div>
                                        <div className=""><a className="color-white medium" href="mailto:hello+onegoodturn@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                                    </div>
                                </div>
                            </div>  
                        </div>  
                    </div>

                </div>
            </div>
        </div>
    )
}


export default LandingPage;